import { render, staticRenderFns } from "./ProyectosView.vue?vue&type=template&id=a7d344fc&"
import script from "./ProyectosView.vue?vue&type=script&lang=js&"
export * from "./ProyectosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports